import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
})
export class TableComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
